var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-center bg-black text-white p-8"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('common.impersonation', [_vm.fullName]))+" ")]),_c('div',[_vm._v(_vm._s(decodeURIComponent(_vm.impersonationEmail)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }